import { render, staticRenderFns } from "./align-middle.vue?vue&type=template&id=641aa7a1&"
import script from "./align-middle.vue?vue&type=script&lang=js&"
export * from "./align-middle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports